import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";
import dateRange from "../../components/utils/DateRange";

export default (context) => {
  return {
    config: {
      pageSize: 40,
      customPathGet: "admBilling/report/receipts/get/",
      resource: "admBilling/receipts",
      list: false,
      enableContexMenu: false,
      remap: (r) => {
        r.data.Results = r.data.Results.map(e => {e.type = e.type === 0 ? "Recibo de ingreso" : "Nota de ingreso"; return e})
        return r
      },
      remapRow: (form) => {
        form.type = form.type === 0 ? "Recibo de ingreso" : "Nota de ingreso"
        return form
      }
    },

    actions: {
      create: false,
      edit: false,
      delete: false,
      print: true,
      export: true,
      search: true
    },

    extras: {
      items: [
        {id: 0, icon: 'simple-icon-cloud-download', name: 'Descargar recibos', onClick: () => { 
          let content = {
            name: "Descargar recibos masivamente en formato PDF",
            fields: [...dateRange()],
            buttons: [
              {
                label: "Descargar",
                onClick: (ctx) => {
                  ctx.validateForm().then(() => {
                    context.props.setLoader(true)
                    _axios
                      .get('admBilling/report/receipts/zip?from=' + ctx.state.from + '&to=' + ctx.state.to)
                      .then(r => {
                        if (r.status === 0) {
                          if (r.data && r.data.url) window.open(r.data.url)
                          context.toggleRight()
                        }
                        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                        context.props.setLoader(false)
                      }).catch(e => {
                        console.log(e)
                        context.props.setLoader(false)
                      })
                  })
                  .catch(e => { /* console.log(e) */ })
                }
              }
            ]
          }

          context.setState({modalRightContent: content}, () => {
            context.toggleRight() 
          })
        }}
      ],
      itemsInRowsTable: [
        {
          id: 1, icon: 'simple-icon-cloud-download', name: row => row.refId === null ? "Descargar recibo de ingreso" : "Descargar nota de ingreso",
          onClick: (row, ctx) => {
            context.props.setLoader(true)
            let isChild = row.refId !== null
            _axios
              .get('admBilling/receipt/' + row.orderId + '/' + isChild)
              .then(r => {
                if (r.status === 0) {
                  window.URL = window.URL || window.webkitURL;
                  var xhr = new XMLHttpRequest(), a = document.createElement('a'), file;
                  xhr.open('GET', r.data.url, true);
                  xhr.responseType = 'blob';
                  xhr.onload = function () {
                      file = new Blob([xhr.response], { type : 'application/octet-stream' });
                      a.href = window.URL.createObjectURL(file);
                      a.download = r.data.filename;
                      a.click();
                  };
                  xhr.send();
                }
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                context.props.setLoader(false)
              }).catch(e => {
                console.log(e)
                context.props.setLoader(false);
              })
          }
        },
        {
          id: 2, icon: 'simple-icon-pencil', name: "Editar recibo",
          onClick: (row, ctx) => {
            context.getDataById(row.ID)
          }
        }
      ]
    },

    filter: {
      fields: [
        {
          col: 3,
          name: "status",
          value: "",
          type: "select",
          label: "Estado",
          opts: {
            style: 'float-label',
            items: [
              {
                value: -1,
                label: "Todos los recibos"
              },
              {
                value: 0,
                label: "Pendientes de pago"
              },
              {
                value: 1,
                label: "Pagados"
              },
              {
                value: 2,
                label: "Anulados"
              }
            ]
          }
        },
        {
          col: 2,
          name: "type",
          value: "",
          type: "select",
          label: "Tipo",
          opts: {
            style: 'float-label',
            items: [
              {
                value: -1,
                label: "Todos"
              },
              {
                value: 0,
                label: "Recibo de ingreso"
              },
              {
                value: 1,
                label: "Nota de ingreso"
              }
            ]
          }
        },
        {
          col: 3,
          name: "studentId",
          value: "",
          type: "select",
          label: "Alumno",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: "/admStudent/get?pick=true&enrolled=-1",
            withImg: true
          }
        },
        {
          type: "daterange"
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return ctx.state.from || ctx.state.to || Number.isInteger(ctx.state.status) || Number.isInteger(ctx.state.studentId) || Number.isInteger(ctx.state.type)},
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      fields: [
        {
          col: 4,
          name: "type",
          value: "",
          type: "hidden"
        },
        {
          col: 4,
          name: "ID",
          value: "",
          type: "hidden"
        },
        {
          col: 8,
          name: "label1",
          value: (L, state) => state.type === 0 ? `<h5>Recibo de ingreso Nro. ${state.ID}</h5>` : `<h5>Nota de ingreso Nro. ${state.ID}</h5>`,
          type: "label"
        },
        {
          col: 4,
          name: "label2",
          value: (L, state) => state.voided ? `<h5 style="color: #be4242">ANULADO</h5>` : "",
          type: "label",
          renderIf: ctx => ctx.state.voided
        },
        {
          col: 6,
          name: "date",
          value: "",
          type: "datetime",
          label: "Fecha de emisión",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 6,
          name: "datePaid",
          value: "",
          type: "datetime",
          label: "Fecha de vencimiento",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 6,
          name: "doc",
          value: "",
          type: "text",
          label: "DNI",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 6,
          name: "principalName",
          value: "",
          type: "text",
          label: "Nombre",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 4,
          name: "dependantName",
          value: "",
          type: "text",
          label: "Alumno",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 4,
          name: "dependantDoc",
          value: "",
          type: "text",
          label: "Código de alumno",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 4,
          name: "sectionTag",
          value: "",
          type: "text",
          label: "Sección",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 8,
          name: "brief",
          value: "",
          type: "text",
          label: "Concepto",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 4,
          name: "amount",
          value: "",
          type: "text",
          label: "Monto",
          opts: {
            style: 'float-label',
          },
          disabled: true
        },
        {
          col: 12,
          name: "notes",
          value: "",
          type: "textarea",
          label: "Observaciones",
          rules: "max:200",
          opts: {
            style: 'float-label',
          }
        }
      ]
    },

    columns: [
      {
        Header: "Código",
        accessor: "ID"
      },
      {
        Header: "Tipo",
        accessor: "type"
      },
      {
        Header: "Fecha",
        accessor: "date",
        isDate: true
      },
      {
        Header: "Referencia",
        accessor: "refId"
      },
      {
        Header: "Fecha pago",
        accessor: "datePaid",
        isDate: true
      },
      {
        Header: "Vencimiento",
        accessor: "dueDate",
        isDate: true
      },
      {
        Header: "Responsable",
        accessor: "principalName"
      },
      {
        Header: "Nro. Doc.",
        accessor: "doc"
      },
      {
        Header: "Dependiente",
        accessor: "dependantName"
      },
      {
        Header: "Código",
        accessor: "dependantCode"
      },
      {
        Header: "DNI",
        accessor: "dependantDoc"
      },
      {
        Header: "Sección",
        accessor: "sectionTag"
      },
      {
        Header: "Concepto",
        accessor: "brief"
      },
      {
        Header: "Monto",
        accessor: "amount",
        isDecimal: true,
        minWidth: 70
      },
      {
        Header: "Nro cuota",
        accessor: "code"
      },
      {
        Header: "Pagado",
        accessor: "paid",
        isBool: true
      },
      {
        Header: "Anulado",
        accessor: "voided",
        isBool: true
      },
      {
        Header: "Observaciones",
        accessor: "notes"
      },
      {
        Header: "ID",
        accessor: "orderId",
        hidden: true
      }
    ]
  }
}
